function normRole(role) {
  return String(role ?? '')
    .trim()
    .toLowerCase();
}

export function isGodMode(userOrFlag) {
  if (userOrFlag === true) return true;
  if (userOrFlag && typeof userOrFlag === 'object') return !!userOrFlag.godMode;
  return false;
}

export function isDepartmentHeadRole(role) {
  const r = normRole(role);
  return r === 'department_head' || r === 'руководитель отдела';
}

/** Сопоставление роли с admin/hr без учёта регистра и лишних пробелов */
export function isAdminOrHrRole(role, user) {
  if (isGodMode(user) || isGodMode(role)) return true;
  const r = normRole(role);
  return r === 'admin' || r === 'hr';
}

export function isAdminRole(role, user) {
  if (isGodMode(user)) return true;
  return normRole(role) === 'admin';
}

export function isHrRole(role) {
  return normRole(role) === 'hr';
}

/** Роль директора (латиница, «директор», «руководитель» в профиле). */
export function isDirectorRole(role, user) {
  if (isGodMode(user)) return true;
  const r = normRole(role);
  return r === 'director' || r === 'директор' || r === 'руководитель';
}

export function isHrOrDirectorRole(role, user) {
  return isHrRole(role) || isDirectorRole(role, user) || isGodMode(user);
}

/**
 * В модалке «Управление»: заявки на регистрацию, управление названием приложения — только администратор.
 */
export function canSeeManagementRegistrationAndAppTitle(role, user) {
  return isAdminRole(role, user);
}

/**
 * Кнопка «Права пользователей» (модалка списка сотрудников компании): администратор, HR, директор.
 */
export function canSeeManagementUserRights(role, user) {
  return isAdminRole(role, user) || isHrOrDirectorRole(role, user);
}

/** Массовое завершение сеансов 1С (кнопка / API) — администратор, HR, директор. */
export function canMassShutdown1cRole(role, user) {
  return isAdminRole(role, user) || isHrOrDirectorRole(role, user);
}
